import * as styles from './Footer.module.scss';

import React, { memo, useState } from 'react';
import cn from "classnames"
import Input from 'src/components/ui/Input';
import Button from 'src/components/ui/Button';

import logo from 'src/assets/images/Logo_Black.png';
import vkLogo from 'src/assets/images/vk.svg';
import tgLogo from 'src/assets/images/tg.svg';
import subscribe from 'src/api/subscribe';
import { Link } from 'gatsby';

const Footer = () => {
  const [email, setEmail] = useState('');
  const currentYear = new Date().getFullYear();

  const onSubmit = () => {
    subscribe(email);
    setEmail('');
  };

  return (
    <div className={cn(styles.footer)} id='footer'>
      <div className={cn(styles.footer__slice, styles.footer__slice_logo)}>
        <Link to="/">
          <img className={styles.footer__logo} src={logo} alt="logo" />
          <p className={styles.footer__item}>&#169; GH Campus, 2021-{currentYear}</p>
        </Link>
      </div>
      <div className={styles.footer__column}>
        <Link className={styles.footer__item} to="/documentation">Сведения об образовательной организации</Link>
        <a className={styles.footer__item} href="/notification_license.pdf" target='_blank'>Лицензия &#8470;3518</a>
        <div className={styles.footer__social}>
          <a href="https://vk.com/pixel_map" target="_blank"><img className={styles.footer__icon} src={vkLogo} alt="vk" /></a>
          <a href="https://t.me/pixel_map" target="_blank"><img className={styles.footer__icon} src={tgLogo} alt="telegram" /></a>
        </div>
      </div>
      <div className={cn(styles.footer__slice, styles.footer__slice_subscribe)}>
        <p className={styles.footer__subscription}>Подпишитесь на рассылку</p>
        <div className={styles.footer__form}>
          <Input
            className={styles.footer__input}
            value={email}
            onChange={setEmail}
            placeholder="E-mail"
            name="email"
            small
          />
          <Button
            className={styles.footer__button}
            onClick={onSubmit}
            disabled={!/(.+)@(.+)/.test(email)}
          >
            Подписаться
          </Button>
        </div>
      </div>
    </div>
  )
}

export default memo(Footer);
